import { FocusEventHandler, Fragment, ReactNode } from "react";

import { FormattedMessage, useIntl } from "react-intl";

import { ErrorMessage, Field, HelperMessage } from "@atlaskit/form";
import TextArea from "@atlaskit/textarea";

import { Link } from "@/libraries/design/components";
import { DEFAULT_VALUES } from "@/libraries/web-framework";

export const QuestionField = (
    formType: string,
    onBlur: FocusEventHandler<HTMLTextAreaElement> | undefined
) => {
    const intl = useIntl();
    const yourQuestionErrorMessage = intl.formatMessage({
        id: "productFeatures.yourQuestionErrorMessage",
        defaultMessage: "Please provide a question."
    });

    const yourQuestionHelperMessageSupportEn =
        formType === "migration-options" ? (
            <FormattedMessage
                id="enterpriseContactSales.yourQuestionHelper.entIdentifier"
                defaultMessage={
                    "Include details like your SENs, ENs or Cloud URLs you're migrating from."
                }
            />
        ) : (
            <FormattedMessage
                id="pricingQuotes.yourQuestionHelper.includeDetails.entIdentifier"
                defaultMessage={
                    "Include details like your SENs (SEN-123456), ENs (E-XXX) or if you started a trial."
                }
            />
        );

    return (
        <Field
            name={"opportunity_Description__c"}
            label={
                intl.formatMessage({
                    id: "enterpriseContactSales.yourQuestion",
                    defaultMessage: "Your question"
                }) + " *"
            }
        >
            {({ fieldProps, error }) => (
                <Fragment>
                    {/* @ts-ignore */}
                    <TextArea {...fieldProps} onBlur={onBlur} />
                    {(error && (
                        <ErrorMessage>{yourQuestionErrorMessage}</ErrorMessage>
                    )) || (
                        <HelperMessage>
                            {yourQuestionHelperMessageSupportEn}
                        </HelperMessage>
                    )}
                    <HelperMessage>
                        {" "}
                        {
                            <FormattedMessage
                                id="enterpriseContactSales.yourQuestionHelper.findYourSen.entIdentifier"
                                defaultMessage={
                                    "Product admins, see how to <findYourSenLink>find your SEN</findYourSenLink> or how to <findYourEnLink>find your EN</findYourEnLink>."
                                }
                                values={{
                                    ...DEFAULT_VALUES,
                                    findYourSenLink: (text: ReactNode) => (
                                        <Link
                                            text={text as unknown as string}
                                            href="https://confluence.atlassian.com/support/how-to-find-your-support-entitlement-number-sen-229840018.html"
                                            type={"inline"}
                                        />
                                    ),
                                    findYourEnLink: (text: ReactNode) => (
                                        <Link
                                            text={text as unknown as string}
                                            href="https://support.atlassian.com/subscriptions-and-billing/docs/understand-the-improved-atlassian-billing-experience/#What-are-the-key-differences"
                                            type={"inline"}
                                        />
                                    )
                                }}
                            />
                        }{" "}
                    </HelperMessage>
                </Fragment>
            )}
        </Field>
    );
};
